import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'
import store from './store'  // 引入 store
import i18n from './lang'
import VueAMap from 'vue-amap'
Vue.use(VueAMap)
VueAMap.initAMapApiLoader({
  key: '4bdaf3519e5b654096db1455959d13bc', // 需替换为自己申请的Key
  plugin: ['AMap.Marker', 'AMap.InfoWindow'],
  v: '1.4.4'
})
// 引入全局 CSS 文件（注意路径要正确）
import './styles/global.css'  // 引入全局样式
import './styles/iconfont.css'  // 引入ICON图标库


import ECharts from 'vue-echarts' // 引入 vue-echarts 组件
import echarts from 'echarts' // 引入 ECharts 实例

// 关键：将 ECharts 实例绑定到组件
Vue.component('v-chart', {
  extends: ECharts,
  props: {
    echarts: {
      default: () => echarts
    }
  }
})

// 按需引入 ECharts 模块（地图需要这些）
import 'echarts/lib/chart/map' // 地图图表模块
import 'echarts/lib/component/tooltip' // 提示框组件（可选）
import 'echarts/map/js/china.js' // 中国地图数据

import BaiduMap from 'vue-baidu-map'

// 全局注册所有百度地图组件，同时传入 AK（无需手动引入单个组件）
Vue.use(BaiduMap, {
  ak: 'jmSe6E9NCsWOOMe1bW4dakistlPyW1nc' // 必须替换为你申请的真实AK
})


import BackToTop from './components/BackToTop.vue'
import FloatingActions from './components/FloatingActions.vue'
import MenuBar from './components/MenuBarPage.vue'
import FooterBar from './components/FooterBar.vue'
import FullscreenPoster from './components/FullscreenPoster.vue'
import RealPageLoading from './components/RealPageLoading.vue';

// 全局注册返回顶部组件
Vue.component('RealPageLoading', RealPageLoading);
Vue.component('BackToTop', BackToTop)
Vue.component('FloatingActions', FloatingActions)
Vue.component('MenuBar', MenuBar)
Vue.component('FooterBar', FooterBar)
Vue.component('FullscreenPoster', FullscreenPoster)

// 2. 创建进度条实例并挂载到Vue原型（全局可调用）
const loadingInstance = new Vue(RealPageLoading).$mount();
// 将进度条DOM插入到页面body最前面
document.body.insertBefore(loadingInstance.$el, document.body.firstChild);
// 挂载到Vue原型，全局通过 this.$pageLoading 调用
Vue.prototype.$pageLoading = loadingInstance;


import PerfectScrollbar from 'perfect-scrollbar'
import 'perfect-scrollbar/css/perfect-scrollbar.css'


// 初始化 html 元素的滚动条
document.addEventListener('DOMContentLoaded', () => {
  // 选择根元素（html 或 body，推荐 html）
  const rootElement = document.documentElement; // 对应 <html> 标签
  
  // 确保根元素高度充满屏幕
  rootElement.style.height = '100%';
  rootElement.style.overflow = 'auto'; // 允许滚动
  
  // 初始化 perfect-scrollbar
  new PerfectScrollbar(rootElement, {
    suppressScrollX: true, // 隐藏水平滚动条（可选）
    wheelPropagation: false // 避免滚动事件冒泡（可选）
  });
})


import AV from 'leancloud-storage'
AV.init({
  appId: '9rXqIZHsGPUfozzLKmCRzDaU-gzGzoHsz',
  appKey: 'W4rV92VWVQq2GRbXEjf93tSb',
  serverURL: 'https://9rxqizhs.lc-cn-n1-shared.com'
})
Vue.prototype.$AV = AV
Vue.config.productionTip = false
import 'animate.css'
import WOW from 'wowjs'
Vue.prototype.$wow = new WOW.WOW({
  boxClass: 'wow', // 触发动画的元素类名（默认即可）
  animateClass: 'animated', // 动画类名（与 animate.css 对应）
  offset: 0, // 元素距离可视区域多少像素时触发动画
  mobile: true, // 是否在移动设备上执行动画
  live: true // 是否监听动态添加的元素
})


// 显式挂载到 window，确保全局可访问
window.WOW = WOW;

// 导入 Vue Router
import VueRouter from 'vue-router'
import ElementUI from 'element-ui'
// 引入 Element UI 默认样式（必须保留，否则图标和基础样式丢失）
import 'element-ui/lib/theme-chalk/index.css'
// 引入自定义主题（放在默认样式之后，确保覆盖）
// import './styles/element-theme.css'
import './styles/element-cover.css' // 引入直接覆盖的样式

Vue.use(ElementUI)
// 路由配置文件（需要自己创建）
import router from './router'
// 使用路由和 Element UI
Vue.use(VueRouter)

// 创建全局事件总线
Vue.prototype.$bus = new Vue()
Vue.prototype.$axios = axios

// 路由后置守卫
router.afterEach((to) => {
  if (to.path === '/login') {
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0
  }
})


// 检测并跳转的函数
function checkAndRedirect() {
  const MOBILE_WIDTH_THRESHOLD = 768;
  const isSmallScreen = window.innerWidth < MOBILE_WIDTH_THRESHOLD;
  
  // 增强版移动设备检测，特别加入微信浏览器判断
  const userAgent = navigator.userAgent.toLowerCase();
  const isMobileDevice = /iphone|ipad|ipod|android|webos|blackberry|iemobile|opera mini|mobile/.test(userAgent);
  const isWechatBrowser = /micromessenger/.test(userAgent); // 检测微信浏览器
  
  // 精准判断是否在移动站点
  const isOnMobileSite = window.location.hostname === 'm.3pg.cn';
  
  // 调试信息（可在浏览器控制台查看）
  // console.log('屏幕宽度:', window.innerWidth);
  // console.log('是否移动设备:', isMobileDevice);
  // console.log('是否微信浏览器:', isWechatBrowser);
  // console.log('是否在移动站点:', isOnMobileSite);
  
  // 跳转逻辑：微信浏览器+移动设备+不在移动站 或 小屏幕+不在移动站
  if (((isMobileDevice && isWechatBrowser) || isSmallScreen) && !isOnMobileSite) {
    console.log('准备跳转到移动站点');
    window.location.href = 'http://m.3pg.cn';
  }
}

// 初始化检测
checkAndRedirect();

// 优化的 resize 事件监听（带防抖）
let resizeTimer;
window.addEventListener('resize', () => {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(checkAndRedirect, 200);
});

// 页面加载完成后再检测一次
window.addEventListener('load', checkAndRedirect);

// 针对微信浏览器可能的延迟加载问题，增加延迟检测
setTimeout(checkAndRedirect, 1000);




// 初始化时检测
checkAndRedirect();


new Vue({
  router,  // 注入路由
  store,
  i18n, // 注入国际化实例
  render: h => h(App),
}).$mount('#app')
